import { Outlet } from "react-router-dom";

import { Footer } from "../components/footer";
import { Header } from "../components/header";
import { AccountProvider } from "../components/account/context";
import { SiteProvider } from "./context";
import { SiteModal } from "./site-modal";
import { ClinicalAccountProvider } from "../components/account/clinical-context";
import { GoogleAnalytics } from "../components/google-analytics";
import { Hotjar } from "../components/hotjar";

const Layout = () => {
  return (
    <SiteProvider>
      <ClinicalAccountProvider>
        <AccountProvider>
          <Header />
          <Outlet />
          <Footer />
          <SiteModal />
          <GoogleAnalytics />
          <Hotjar />
        </AccountProvider>
      </ClinicalAccountProvider>
    </SiteProvider>
  );
};

export default Layout;
